import React from "react";
import { useTranslation } from "react-i18next";
import CodeList from "../../../lib/CodeList";

const codeList = new CodeList();

const item = {
  id: "433adc4a-8853-448f-bacf-61f0a2696946",
  cnmMainKey: "433adc4a-8853-448f-bacf-61f0a2696946",
  cnmType: "5",
  cnmSite: "Z0001",
  cnmCompNM: "(주)지비티에스",
  cnmTreeKey: "",
  cnmAllow: "",
  cnmKind: "",
  cnmPWD: "",
  cnmPicMain:
    "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/gbts/companyInfo/20240125142859_GBTS2.png?GBTS2.png",
  cnmName: "LOGIWORK 상태알림",
  cnmDesc: "GBTS에서 엄선한 하루 5개, 한 줄 뉴스를 매일 아침 전달 드립니다",
  cnmLastDelYN: "N",
  cnmLastMSG: "기분좋은 하루되세요^^",
  cnmLastTime: "2024-02-01 08:54:34",
  cnmLastUser: "hskim@bstc.kr",
  cnmLastUserSite: "E0001",
  cnmCreator: "hskim@gbts.co.kr",
  cnmCreatorSite: "Z0001",
  cnmCreatDate: "2024-01-16 09:46:06",
  cnmUpdateDate: "2024-02-01 08:54:34",
  cnmDelYN: "N",
  COMP_LOGO:
    "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/gbts/companyInfo/20240125142859_GBTS2.png?GBTS2.png",
  cnmSubscribe: "0",
  cnmUnreadCnt: "1",
  cniMainKey: "433adc4a-8853-448f-bacf-61f0a2696946",
  cniSites:
    "A0005|A0009|A0010|A0011|A0015|A0017|A0020|A0023|A0024|A0025|A0026|A0027|A0028|A0029|A0030|A0032|A0035|A0036|A0037|A0038|A0039|A003E|A003F|A003G|A003H|A003I|A003J|A003M|A003N|A003O|A003P|A003R|A003U|A003V|A003W|A003X|A003Z|A0040|A0041|A0042|A0043|A0044|A0045|A0046|A0047|A0048|A0049|A004A|A004B|A004C|A004D|A004E|A0050|A0051|A0052|A0053|A0054|A0055|A0056|A0057|A0058|A0059|A0061|A0062|A0063|A0064|A0065|A0066|A0067|A0068|A0070|A0071|A0072|A0073|A0074|A0075|A0076|A0077|A0078|A0079|A0080|A0081|A0082|A0083|A0084|A0085|A0086|A0087|A0088|A0089|A0090|A0091|A0092|A0093|A0094|A0095|A0096|A0097|A0098|A0099|A0100|A0101|A0106|A0108|A0109|A0111|A0112|A0114|A0115|A0116|A0117|A0118|A0119|A0121|A0122|A0123|A0124|A0125|A0126|A0127|A0128|A0129|A0130|A0131|A0132|A0133|A0134|A0135|A0136|A0137|A0138|A0139|A0141|A0142|A0143|A0144|A0145|A0146|A0147|A0148|A0149|A0150|A0151|A0152|A0153|A0154|A0155|A0156|A0157|A0158|A0159|A0160|A0161|A0162|A0163|A0164|A0165|A0166|A0167|A0168|A0169|A0170|A0171|A0172|A0173|A0174|A0175|A0176|A0177|A0178|A0179|A0180|A0181|A0182|A0183|A0184|A0185|A0186|A0188|A0189|A0190|A0191|A0192|A0193|A0194|A0195|A0196|A0197|A0198|A0199|A0200|A0201|A0202|A0203|A0204|A0205|A0206|A0207|A0208|A0209|A0210|A0211|A0212|A0213|A0214|A0215|A0216|A0217|A0218|A0219|A0220|A0221|A0222|A0223|A0224|A0225|A0226|A0227|A0228|A0229|A0230|A0231|A0232|A0233|A0234|A0235|A0236|A0237|A0238|A0239|A0240|A0241|A0242|A0243|A0244|A0245|A0246|A0247|A0248|A0249|A0250|A0251|A0252|A0253|A0254|A0255|A0256|A0257|A0258|A0259|A0260|A0261|A0262|A0263|A0264|A0265|A0266|A0267|A0268|A0269|A0270|A0271|A0272|A0273|A0274|A0276|A0277|A0278|A0279|A027A|A027B|A027C|A027D|A027E|A027F|A027G|A027H|A027I|A027J|A027K|A027L|A027M|A027N|A0288|A0289|A028A|A028B|A028I|A028J|A028L|A028M|A028N|A028O|A028P|A028Q|A028R|A028S|A028T|A028U|A028V|A028W|A028X|A028Y|A0299|A029A|A029B|A029C|A029D|A9100|A9900|B0004|B0005|B0006|B0007|B0008|B0009|B0010|B0015|B0016|B0017|B0019|B001D|B001E|B001F|B001G|B001H|B001I|B001J|B001K|B001L|B001N|B001P|B001Q|B001R|B001T|B001U|B001V|B001W|B001X|B001Y|B001Z|B0020|B0023|B0024|B0025|B0026|B0027|B0030|B0031|B0032|B0033|B0034|B0036|B0037|B0038|B0039|B003A|B003C|B003D|B003E|B003F|B003G|B003H|C0005|C0007|C0009|C0010|C0012|C002V|C002W|C002X|C002Y|D0006|D0010|E0001|E0002|E0003|E0004|E0005|F0007|F0008|F0009|F000C|F000E|F000G|F000H|F000I|Y0001|Z0001|A029E|B003I|B003J|A029F",
  cniCreator: "hskim@bstc.kr",
  cniCreatorSite: "E0001",
  cniCreatDate: "2024-01-16 09:46:24",
  cniUpdateDate: "2024-01-31 09:17:58",
  isEntire: true,
  LastTime: "2024-02-01 08:54:34",
};

export default function LogiworkWorkStateAlarm(props) {
  const { openNewsChatRoom } = props;
  const { t } = useTranslation();

  return (
    <div
      className="d-flex flex-row justify-content-start align-items-center cursor_pointer rounded p-2 mb-2 bg-blue-light"
      onClick={() => {
        codeList.Modal.current.alert(
          t("logiTalk.favList.newsTalk.scheduledToOpenMSG")
        );
        // openNewsChatRoom(item)
      }}
    >
      <div className="overflow-hidden mr-2">
        <div
          className="border"
          style={{
            borderRadius: "45%",
            width: 46,
            height: 46,
            background: `url(https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20240201133843_logiwork_main_logo.png) #fff 50% 50%/contain no-repeat`,
          }}
        />
      </div>
      <div>
        <p className="font-weight-bold">
          [{t("logiTalk.favList.newsTalk.scheduledToOpen")}] {item.cnmName}
        </p>
        <p className="font-size-08">{item.cnmCompNM}</p>
      </div>
    </div>
  );
}
